/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Esey Woldeabzghi
*/
import { useCallback } from 'react';
import useMastheadBounds from '../use-masthead-bounds/use-masthead-bounds';

var useScrollIntoView = function useScrollIntoView() {
  var _useMastheadBounds = useMastheadBounds(),
      mastheadBottom = _useMastheadBounds.bottom; // First, aligns target to the top of viewport 
  // then scrolls down by the amount covered by the masthead


  var scrollIntoView = useCallback(function (targetEl) {
    if (!targetEl || !targetEl.scrollIntoView) {
      return; // no-op
    }

    targetEl.scrollIntoView(true);

    var _targetEl$getBounding = targetEl.getBoundingClientRect(),
        targetTop = _targetEl$getBounding.top;

    var scrolledBehindMasthead = targetTop < mastheadBottom;

    if (scrolledBehindMasthead) {
      var pixelsBehindMasthead = mastheadBottom - targetTop;
      window.scrollBy(0, -1 * pixelsBehindMasthead);
    }
  }, [mastheadBottom]);
  return scrollIntoView;
};

export default useScrollIntoView;